import SubEmpreitada from "@/api/SubEmpreitada";

export const sub_empreitada = {
    state: () => ({
    }),
    mutations: {
    },
    getters: {
    },
    actions: {
        async listSubEmpreitadas(params, id) {
            return new Promise((resolve, reject) => {
                SubEmpreitada.all(id)
                    .then(response => {
                        resolve(response);
                    }).catch(err => {
                        reject(err);
                    });
            });
        },
        async createSubEmpreitadaUnidade(params, data) {
            return new Promise((resolve, reject) => {
                SubEmpreitada.createSubEmpreitadaUnidade(data)
                    .then(response => {
                        resolve(response);
                    }).catch(err => {
                        reject(err);
                    });
            });
        },
        async getListSubEmpreitadaUnidades() {
            return new Promise((resolve, reject) => {
                SubEmpreitada.getListSubEmpreitadaUnidades()
                    .then(response => {
                        resolve(response);
                    }).catch(err => {
                        reject(err);
                    });
            });
        },
        async deleteSubEmpreitadaUnidades(params, id) {
            return new Promise((resolve, reject) => {
                SubEmpreitada.deleteSubEmpreitadaUnidades(id)
                    .then(response => {
                        resolve(response);
                    }).catch(err => {
                        reject(err);
                    });
            });
        },
    }
}